import React , {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {Close, CloseCircledIcon, ExpiredIcon, ExpiringIcon, PaymentIcon, PendingPaymentIcon, RedCloseIcon, WordIcon} from "../../icons/icons";
import {Get} from "../../apis/api";
import {useSelector} from "react-redux";

const DashboardTopSection = () => {
  const {t} = useTranslation()
  const [data, setData] = useState([])
  const [userId, setUseID] = useState(null);
  const user = useSelector((state) => state.user.user)

  useEffect(() => {
       handleList()
  } ,[])


  const handleList = () => {
    if(user?.role_key === "agent" ) {
      Get(`agent/profile/analysis` ).then((res) =>{
        setData(res?.details?.data)
      }).finally(() => {

      })
    } else {
      Get(`admin/users/analysis` ).then((res) =>{
        setData(res?.details?.data)
      }).finally(() => {

      })
    }

  }

  return (
    <div className={"grid grid-cols-2 lg:grid-cols-5 md:grid-cols-5 gap-5 md:gap-4 text-sm lg:text-base [&>div]:pb-2 [&>div]:lg:pb-2"}>
      <div className={"p-4 pb-0  flex flex-col  gap-3 rounded-lg shadow !bg-main col-span-2 lg:col-span-1"}>
        <div className={"flex"}>
          <WordIcon color={"#ffff"}/>
          <span className={"text-primary-400   text-white"}>
          {t("allVisaRequest")}
        </span>
        </div>
        <div className={"font-semibold text-xl lg:text-2xl text-primary-400 text-white"}>{data?.all_visas}</div>
      </div>
      <div className={"p-4 pb-0  flex flex-col gap-3 rounded-lg shadow !bg-main col-span-1"}>
        <div className={"flex"}>
          <ExpiringIcon color={"#ffff"}/>
          <span className={"text-primary-400   text-white"}>
          {t("expiringVisas")}
        </span>
        </div>
        <div className={"font-semibold text-lg lg:text-2xl text-primary-400 text-white"}>{data?.expiring_visas}</div>
      </div>
      <div className={"p-4 pb-0  flex flex-col gap-3 rounded-lg shadow !bg-main col-span-1"}>
        <div className={"flex items-center -mt-1"}>
          <ExpiredIcon color={"#ffff"}/>
          <span className={"text-primary-400   px-2 text-white"}>
          {t("expiredVisas")}
        </span>
        </div>
        <div className={"font-semibold text-lg lg:text-2xl text-primary-400 text-white"}>{data?.expired_visas}</div>
      </div>
      <div className={"p-4 pb-0  flex flex-col gap-3 rounded-lg shadow !bg-main col-span-1"}>
        <div className={"flex items-center -mt-1"}>
          <PendingPaymentIcon  color={"#ffff"}/>
          <span className={"text-primary-400   px-2 text-white"}>
          {t("pendingPayment")}
        </span>
        </div>
        <div className={"font-semibold text-lg lg:text-2xl text-primary-400 text-white"}>{data?.awaiting_payment}</div>
      </div>

      <div className={"p-4 pb-0  flex flex-col gap-3 justify-between rounded-lg shadow !bg-main col-span-1"}>
        <div className={"flex items-center -mt-1"}>
          <CloseCircledIcon  className="w-8 h-8 text-white"/>
          <span className={"text-primary-400   px-2 text-white"}>
          {t("Canceled")}
        </span>
        </div>
        <div className={"font-semibold text-lg lg:text-2xl text-primary-400 text-white"}>{data?.cancelled_visas}</div>
      </div>
    </div>
  );
};

export default DashboardTopSection;
